export default __webpack_public_path__ + "static/media/non_actif_masque_dark.6f82c167.svg";